import { createStore } from 'redux';
import reducers from './reducers';
import storeEnhancer from './enhancer';

const initialStoreState = {};
export default (model) => createStore(reducers(model), initialStoreState, storeEnhancer);



// WEBPACK FOOTER //
// ./src/client/js/store/createStore.js